import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useThemeMode } from '../App';

export default function Navigation() {
  const { mode, toggleMode } = useThemeMode();
  const location = useLocation();
  const [active, setActive] = useState('');

  useEffect(() => {
    if (location.pathname !== '/') { setActive('articles'); return; }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) setActive(entry.target.id); });
    }, { rootMargin: '-15% 0px -65% 0px' });
    ['home', 'articles', 'about', 'contact'].forEach(id => {
      const section = document.getElementById(id);
      if (section) observer.observe(section);
    });
    return () => observer.disconnect();
  }, [location.pathname]);

  return (
    <header className="site-header">
      <div className="page-width header-inner">
        <Link className="wordmark" to="/" aria-label="K1r44 home">k1r44<span aria-hidden="true">.</span></Link>
        <nav className="main-nav" aria-label="Main navigation">
          {[['Writing', 'articles'], ['About', 'about'], ['Contact', 'contact']].map(([label, id]) => (
            <Link key={id} to={`/#${id}`} className={active === id ? 'nav-link is-active' : 'nav-link'} aria-current={active === id ? 'location' : undefined}>{label}</Link>
          ))}
        </nav>
        <button className="theme-button" type="button" onClick={toggleMode} aria-label={`Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`} title={`Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`}>
          <span className="theme-symbol" key={mode}>{mode === 'dark' ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}</span>
        </button>
      </div>
    </header>
  );
}
